<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else>Adicionar {{ equipment }}</h5>
          </div>
          <div class="col-xs-12">
            <b-form-text id="input-name">Nome *</b-form-text>
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <b-form-input
              v-model="form.NAME"
              placeholder="Informe o nome"
              maxlength="24"
              id="input-name"
              size="sm"
              :formatter="notEmpty"
              aria-describedby="nameInput nameInputLiveFeedback"
              :state="nameState && notRepeatedName"
            />
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text id="input-maker">Fabricante *</b-form-text>
            <!-- <b-form-text v-show="form.MAKER">Fabricante *</b-form-text> -->
            <b-form-input
              v-model="form.MAKER"
              placeholder="Fabricante *"
              maxlength="24"
              size="sm"
              id="input-maker"
              :formatter="notEmpty"
              aria-describedby="makerInputLiveFeedback"
              :state="makerState"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!makerState"
              id="makerInputLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>

            <b-form-text> Tipo de acionamento: </b-form-text>
            <b-form-radio-group v-model="form.MODE" size="sm">
              <b-form-radio
                v-for="(mode, index) in modelMode"
                :key="index"
                :value="index"
                >{{ mode }}</b-form-radio
              >
            </b-form-radio-group>

            <b-form-text id="input-open">Ativado *</b-form-text>
            <!-- <b-form-text v-show="form.OPEN">Open *</b-form-text> -->
            <b-form-input
              v-model="form.OPEN"
              id="input-open"
              aria-describedby="openInputLiveFeedback"
              placeholder=" "
              type="number"
              size="sm"
              :state="openState"
              :min="0"
            />
            <b-form-invalid-feedback
              v-if="!openState"
              id="openInputLiveFeedback"
            >
              Campo inválido.
            </b-form-invalid-feedback>

            <b-form-text id="input-close">Desativado *</b-form-text>
            <!-- <b-form-text v-show="form.CLOSE">Close *</b-form-text> -->
            <b-form-input
              v-model="form.CLOSE"
              id="input-close"
              size="sm"
              aria-describedby="closeInputLiveFeedback"
              placeholder=" "
              type="number"
              :state="closeState"
              :min="0"
            />
            <b-form-invalid-feedback
              v-if="!closeState"
              id="closeInputLiveFeedback"
            >
              Campo inválido.
            </b-form-invalid-feedback>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque:
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn
          size="sm"
          variant="outline-secondary"
          @click="$emit('close-form')"
          class="mr-1 ml-2"
        >
          Fechar
        </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2">
          Salvar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
export default {
  name: "actuator-form",
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    modelMode: Array,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        MAKER: "",
        MODE: 0,
        OPEN: null,
        CLOSE: null,
      },
      openState: true,
      closeState: true,
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.form.NAME = this.itemToEdit.NAME;
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.MAKER = this.itemToEdit.MAKER;
          this.form.MODE = this.itemToEdit.MODE;
          this.form.OPEN = this.itemToEdit.OPEN;
          this.form.CLOSE = this.itemToEdit.CLOSE;
        }
      }
    },
  },
  computed: {
    nameState() {
      return !!this.form.NAME;
    },
    makerState() {
      return !!this.form.MAKER;
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.openState = true;
      this.closeState = true;
      this.form = {
        NAME: "",
        MAKER: "",
        MODE: 0,
        OPEN: null,
        CLOSE: null,
      };
    },
    validateNivelMode() {
      if (this.form.OPEN == 0 || this.form.OPEN == 1) {
        if (this.form.CLOSE == 0 || this.form.CLOSE == 1) {
          if (this.form.OPEN != this.form.CLOSE) return true;
          else {
            this.openState = false;
            this.closeState = false;
            return false;
          }
        } else {
          this.closeState = false;
          return false;
        }
      } else {
        this.openState = false;
        return false;
      }
    },
    validatePulseMode() {
      if (this.form.OPEN <= 1000 && this.form.OPEN >= 0) {
        if (this.form.CLOSE <= 1000 && this.form.CLOSE >= 0) {
          this.openState = false;
          this.closeState = false;
          return true;
        } else {
          this.closeState = false;
          return false;
        }
      } else {
        this.openState = false;
        return false;
      }
    },
    checkOPENCLOSE() {
      if (this.form.MODE == 0) return this.validateNivelMode();
      else if (this.form.MODE == 1 || this.form.MODE == 2)
        return this.validatePulseMode();
      else if (this.form.MODE < this.modelMode.length) return true;
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.makerState,
        this.checkOPENCLOSE(),
      ];
      let erros = [
        "Nome é obrigatório.",
        "Nome escolhido já está em uso. Verifique.",
        "Fabricante é obrigatório.",
        "Valores definidos para open e close podem estar fora de padrão.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .ccontainer-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0;
    margin-right: 0;
  }
  #form, #details {
    padding-top: 1em;
    /* padding-top: 80px; */
}
}
</style>
